import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ReactConfetti from 'react-confetti';
import MonthlyTimer from '../components/MonthlyTimer';
import babyPlaceholder from '../assets/images/1.jpeg';
import './Home.css';

function Home() {
  const [windowDimensions, setWindowDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });
  const [isEvent, setIsEvent] = useState(false);
  const [eventDetails, setEventDetails] = useState({ title: '', description: '' });

  useEffect(() => {
    const handleResize = () => {
      setWindowDimensions({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    window.addEventListener('resize', handleResize);
    checkForEvents();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const checkForEvents = () => {
    const today = new Date();
    const birthDate = new Date(2025, 0, 4); // Sofia's birthdate: January 4, 2025
    
    // Uncomment this line for testing the event banner
    // setIsEvent(true); setEventDetails({ title: 'Тестовый праздник!', description: 'Это тестовая демонстрация праздничного баннера и конфетти.' }); return;
    
    // Check if today is the birthday
    if (today.getDate() === birthDate.getDate() && today.getMonth() === birthDate.getMonth()) {
      setIsEvent(true);
      const age = today.getFullYear() - birthDate.getFullYear();
      setEventDetails({
        title: `С Днём Рождения, София!`,
        description: `Сегодня мне исполняется ${age} ${age === 1 ? 'год' : age < 5 ? 'года' : 'лет'}! Это особенный день для меня и моей семьи.`
      });
      return;
    }
    
    // Check if today is a monthly milestone (same day of month as birth date)
    if (today.getDate() === birthDate.getDate()) {
      const monthsPassed = (today.getFullYear() - birthDate.getFullYear()) * 12 + today.getMonth() - birthDate.getMonth();
      if (monthsPassed > 0) {
        setIsEvent(true);
        setEventDetails({
          title: `Мне исполняется ${monthsPassed} ${getMonthWord(monthsPassed)}!`,
          description: 'Сегодня я отмечаю свой месячный юбилей! Посмотрите, как я выросла за это время.'
        });
        return;
      }
    }
    
    // Add more special events here as needed
  };
  
  const getMonthWord = (months) => {
    if (months === 1) return 'месяц';
    if (months >= 2 && months <= 4) return 'месяца';
    return 'месяцев';
  };

  return (
    <div className="container">
      {isEvent && <ReactConfetti width={windowDimensions.width} height={windowDimensions.height} recycle={true} numberOfPieces={200} />}
      
      {isEvent && (
        <div className="event-banner">
          <h2>{eventDetails.title}</h2>
          <p>{eventDetails.description}</p>
        </div>
      )}
      
      <section className="home-hero">
        <div className="home-content">
          <h1>Добро пожаловать в мир Софии!</h1>
          <p className="home-description">
            Привет! Меня зовут София Скрипунова, и я родилась 4 января 2025 года.
            Это мой личный сайт, где мои родители делятся историей моего роста и развития.
          </p>
          <MonthlyTimer />
        </div>
        <div className="home-image">
          <img src={babyPlaceholder} alt="София Скрипунова" />
        </div>
      </section>
      
      <section className="home-sections">
        <h2>Узнайте больше обо мне</h2>
        <div className="section-cards">
          <div className="section-card">
            <h3>Обо мне</h3>
            <p>Узнайте о значении моего имени, интересные факты обо мне и моём знаке зодиака.</p>
            <Link to="/about" className="section-link">Подробнее</Link>
          </div>
          
          <div className="section-card">
            <h3>Фотогалерея</h3>
            <p>Посмотрите мои фотографии и следите за тем, как я расту месяц за месяцем.</p>
            <Link to="/gallery" className="section-link">Подробнее</Link>
          </div>
          
          <div className="section-card">
            <h3>Астрология</h3>
            <p>Узнайте о моём знаке зодиака и что звёзды говорят о моей личности.</p>
            <Link to="/astrology" className="section-link">Подробнее</Link>
          </div>
          
          <div className="section-card">
            <h3>Вишлист</h3>
            <p>Посмотрите, что мне бы хотелось получить в подарок на предстоящие праздники.</p>
            <Link to="/wishlist" className="section-link">Подробнее</Link>
          </div>
        </div>
      </section>
      
      <section className="home-welcome">
        <h2>Записи от родителей</h2>
        <div className="welcome-message">
          <p>
            Дорогие друзья и родственники!
          </p>
          <p>
            Мы создали этот сайт, чтобы делиться с вами радостными моментами из жизни нашей дочери Софии.
            Здесь вы сможете наблюдать за её ростом, развитием и первыми достижениями.
          </p>
          <p>
            С любовью, Анастасия и Юрий Скрипуновы
          </p>
        </div>
      </section>
    </div>
  );
}

export default Home;